import React, { useEffect, useState } from 'react';

import CardUi from '../components/common/Card';
import {Divider} from "antd";
import axios from "axios";
import {DEFAULT_URL} from "../constants";
import { useNavigate } from 'react-router-dom';

const SavedReports: React.FC = () => {
    const [items, setItems] = useState(['']);
    const navigate = useNavigate();
    useEffect(() => {
        const fetchReports = async () => {
            try {
                const response = await axios({
                    method: 'get',
                    url: `${DEFAULT_URL}saved_reports`,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    withCredentials: true,
                }); // Replace with your API endpoint
                const fetchedItems:any[] = []
                response.data.forEach((report: any, index:number) => {
                    const {report_name, report_tab, section} = report;
                    // @ts-ignore
                    fetchedItems.push(<div onClick={() => navigate('/grid', {
                        state: {
                            ReportName: report_name,
                            Tab: report_tab,
                            Section: section
                        }
                    })}>
                        {report_name}
                    </div>);
                })
                setItems(fetchedItems);
            } catch (error) {
                console.error('Failed to fetch reports:', error);
            }
        };

        void fetchReports();
    }, []);


    useEffect(() => {
        console.log('SavedReports page');
    }, []);

    return (
        <>
            <Divider style={{marginBottom:0}}>
                <h3 style={{ fontSize: '30px', fontWeight: 'bold', fontFamily: 'Arial, sans-serif', color: 'rgb(3 55 120)', letterSpacing: '0.5px' }}>Saved reports</h3>
            </Divider>
            <div
                style={{
                    margin: '60px auto',
                    display: 'flex',
                    gap: '3rem',
                    flexDirection: 'column',
                }}
            >
                <div>
                    <CardUi
                        items={items}
                        title="Custom made reports"
                    />
                </div>

            </div>
        </>
    );
};

export default SavedReports;
